import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";

export const StyledButton = styled(LoadingButton)`
  position: relative;
  overflow: hidden;
  box-shadow: unset !important;

  &::before {
    --size: 0;
    content: "";
    position: absolute;
    left: var(--x);
    top: var(--y);
    width: var(--size);
    height: var(--size);

    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition:
      width 0.2s ease,
      height 0.2s ease;
    border-radius: 50%;
  }
  &:hover::before {
    --size: 400px;
  }
`;

export const Span = styled.span`
  position: relative;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
